(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ContactoController', ContactoController)

    ContactoController.$inject = ["ContactService"];

    function ContactoController(ContactService) {
        var cc = this;

        var url = new URL(window.location.href);

        cc.contact = null;
        cc.loading = true;
        cc.notFound = false;
        cc.contactId = url.searchParams.get('id');
        cc.type = url.searchParams.get('type') || 'contacto';

        // Tipos de contenido reales de la CRM que se relacionan con un contacto.
        cc.viewOptions = [
            { id: 'resumen', name: 'Resumen', icon: 'person', description: 'Datos generales y estado comercial de este contacto.' },
            { id: 'oportunidad', name: 'Oportunidades', icon: 'monetization_on', description: 'Negociaciones comerciales abiertas o cerradas con este contacto.', columns: [
                { field: 'titulo', label: 'Título' },
                { field: 'estado', label: 'Estado' },
                { field: 'importe_estimado', label: 'Importe estimado' },
                { field: 'fecha_cierre_prevista', label: 'Cierre previsto' }
            ]},
            { id: 'pedido', name: 'Pedidos', icon: 'shopping_cart', description: 'Pedidos de compra registrados para este contacto.', columns: [
                { field: 'numero', label: 'Número' },
                { field: 'fecha_pedido', label: 'Fecha' },
                { field: 'estado', label: 'Estado' },
                { field: 'importe', label: 'Importe' }
            ]},
            { id: 'venta', name: 'Ventas', icon: 'point_of_sale', description: 'Ventas y facturación asociadas a este contacto.', columns: [
                { field: 'numero', label: 'Número' },
                { field: 'fecha_venta', label: 'Fecha' },
                { field: 'estado', label: 'Estado' },
                { field: 'importe_total', label: 'Importe' }
            ]},
            { id: 'actividad', name: 'Actividad', icon: 'history', description: 'Llamadas, reuniones y otras gestiones registradas con este contacto.', columns: [
                { field: 'titulo', label: 'Título' },
                { field: 'tipo', label: 'Tipo' },
                { field: 'fecha', label: 'Fecha' },
                { field: 'estado', label: 'Estado' }
            ]},
            { id: 'incidencia', name: 'Incidencias', icon: 'report_problem', description: 'Incidencias o tickets de soporte abiertos por este contacto.', columns: [
                { field: 'codigo', label: 'Código' },
                { field: 'titulo', label: 'Título' },
                { field: 'prioridad', label: 'Prioridad' },
                { field: 'estado', label: 'Estado' }
            ]},
            { id: 'documento', name: 'Documentos', icon: 'description', description: 'Ficheros y documentación adjunta a este contacto.', columns: [
                { field: 'titulo', label: 'Título' },
                { field: 'categoria', label: 'Categoría' },
                { field: 'fecha_documento', label: 'Fecha' },
                { field: 'estado', label: 'Estado' }
            ]},
            { id: 'conversaciones', name: 'Conversaciones', icon: 'mail', description: 'Conversaciones por email, WhatsApp y otros canales conectados.' }
        ];

        cc.selectedOption = cc.viewOptions[0];
        cc.related = {};

        cc.conversaciones = { loading: false, error: false, data: [] };
        cc.hilo = { loading: false, error: false, mensajes: [], canal: null };
        cc.replyText = '';
        cc.replyNote = '';
        cc.replySending = false;
        cc.nuevaConversacion = { loading: false, error: false, canales: [], selected: null, titulo: '', texto: '', enviando: false };

        cc.getcontact = function () {
            cc.loading = true;

            ContactService.GetContact(cc.contactId).then(function (response) {
                cc.contact = response;

                var addressParts = [];

                if (cc.contact.pais_id && cc.contact.pais_id.nombre) {
                    addressParts.push(cc.contact.pais_id.nombre);
                }

                if (cc.contact.poblacion) {
                    addressParts.push(cc.contact.poblacion);

                    if (cc.contact.direccion) {
                        addressParts.push(cc.contact.direccion);
                    }
                }

                cc.contact.address = addressParts.join(', ');
            }, function () {
                cc.contact = null;
                cc.notFound = true;
            }).finally(function () {
                cc.loading = false;
            });
        };

        cc.formatFecha = function (fecha) {
            if (!fecha) {
                return '';
            }

            // MySQL manda "Y-m-d H:i:s" (espacio, no "T"): algunos navegadores
            // (Safari) no lo parsean como fecha válida si no se normaliza a ISO 8601.
            var date = new Date(String(fecha).replace(' ', 'T'));
            if (isNaN(date.getTime())) {
                return fecha;
            }

            return date.toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
        };

        cc.changeView = function (option) {
            cc.selectedOption = option;

            if (option.id === 'conversaciones') {
                cc.loadConversaciones();
            } else if (option.id !== 'resumen') {
                cc.loadRelated(option);
            }
        };

        cc.loadRelated = function (option) {
            if (cc.related[option.id]) {
                return;
            }

            cc.related[option.id] = { loading: true, data: [], error: false };

            ContactService.GetRelacionados(cc.contactId, option.id).then(function (data) {
                cc.related[option.id].data = data;
            }, function () {
                cc.related[option.id].error = true;
            }).finally(function () {
                cc.related[option.id].loading = false;
            });
        };

        cc.editContact = function () {
            if (!cc.contact) {
                return;
            }

            window.location.href = 'update?id=' + cc.contact.id + '&type=contacto';
        };

        // -- Conversaciones (Mensajes): lista de canales con historial, hilo por
        // canal con respuesta, y arranque de conversación nueva por un canal
        // conectado. Misma lógica de envío real (WAHA/RustMailer) que el
        // dashboard, pero en el ContactoController y acotada a este contacto.

        cc.loadConversaciones = function () {
            cc.conversaciones = { loading: true, error: false, data: [] };

            ContactService.GetConversaciones(cc.contactId).then(function (data) {
                cc.conversaciones.data = data;
            }, function () {
                cc.conversaciones.error = 'No se han podido cargar las conversaciones.';
            }).finally(function () {
                cc.conversaciones.loading = false;
            });
        };

        cc.abrirConversacion = function (conversacion) {
            cc.hilo = { loading: true, error: false, mensajes: [], canal: conversacion };
            cc.replyText = '';
            cc.replyNote = '';

            ContactService.GetMensajes(cc.contactId, conversacion.id).then(function (data) {
                cc.hilo.mensajes = data;
            }, function () {
                cc.hilo.error = 'No se ha podido cargar la conversación.';
            }).finally(function () {
                cc.hilo.loading = false;
            });
        };

        cc.discardReply = function () {
            cc.replyText = '';
            cc.replyNote = '';
        };

        // Envuelve el texto seleccionado del textarea de respuesta con el
        // marcador dado. WhatsApp interpreta *texto* como negrita y _texto_
        // como cursiva, así que estos botones producen formato real, no solo
        // cosmético, en ese canal (en el resto simplemente se envían los
        // asteriscos/guiones bajos como texto plano).
        cc.formatReply = function (marker) {
            var textarea = document.getElementById('contactoReplyText');
            if (!textarea) {
                return;
            }

            var start = textarea.selectionStart || 0;
            var end = textarea.selectionEnd || 0;
            var text = cc.replyText || '';
            var selected = text.slice(start, end) || 'texto';

            cc.replyText = text.slice(0, start) + marker + selected + marker + text.slice(end);

            setTimeout(function () {
                textarea.focus();
                textarea.setSelectionRange(start + marker.length, start + marker.length + selected.length);
            });
        };

        cc.enviarRespuesta = function () {
            var texto = (cc.replyText || '').trim();
            var ultimo = cc.hilo.mensajes.length ? cc.hilo.mensajes[cc.hilo.mensajes.length - 1] : null;

            if (!texto || !ultimo) {
                return;
            }

            cc.replySending = true;

            ContactService.Responder(ultimo.id, texto, cc.replyNote).then(function (respuesta) {
                cc.hilo.mensajes.push(respuesta);
                cc.replyText = '';
                cc.replyNote = '';
                cc.loadConversaciones();
            }, function (response) {
                cc.hilo.error = (response && response.msg) || 'No se ha podido enviar la respuesta.';
            }).finally(function () {
                cc.replySending = false;
            });
        };

        cc.abrirNuevaConversacion = function () {
            cc.nuevaConversacion = { loading: true, error: false, canales: [], selected: null, titulo: '', texto: '', enviando: false };
            getNewConversationModal().show();

            ContactService.CanalesDisponibles(cc.contactId).then(function (data) {
                cc.nuevaConversacion.canales = data;
            }, function () {
                cc.nuevaConversacion.error = 'No se han podido cargar tus canales conectados.';
            }).finally(function () {
                cc.nuevaConversacion.loading = false;
            });
        };

        cc.seleccionarCanal = function (canal) {
            if (!canal.puedeEnviar) {
                return;
            }

            cc.nuevaConversacion.selected = canal;
        };

        cc.enviarNuevaConversacion = function () {
            var texto = (cc.nuevaConversacion.texto || '').trim();
            var titulo = (cc.nuevaConversacion.titulo || '').trim();
            var canal = cc.nuevaConversacion.selected;

            if (!texto || !titulo || !canal) {
                return;
            }

            cc.nuevaConversacion.enviando = true;

            ContactService.IniciarConversacion(cc.contactId, canal.id, texto, titulo).then(function () {
                getNewConversationModal().hide();
                cc.loadConversaciones();
            }, function (response) {
                cc.nuevaConversacion.error = (response && response.msg) || 'No se ha podido enviar el mensaje.';
            }).finally(function () {
                cc.nuevaConversacion.enviando = false;
            });
        };

        var newConversationModal = null;

        function getNewConversationModal() {
            if (!newConversationModal) {
                newConversationModal = new bootstrap.Modal(document.getElementById('newConversationModal'));
            }

            return newConversationModal;
        }
    }
})();